import { render, staticRenderFns } from "./Faq.htm?vue&type=template&id=1106977f&scoped=true&"
import script from "./Faq.ts?vue&type=script&lang=js&"
export * from "./Faq.ts?vue&type=script&lang=js&"
import style0 from "./Faq.scss?vue&type=style&index=0&id=1106977f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1106977f",
  null
  
)

export default component.exports